<app-form-group label="Discharge">
  <input [(ngModel)]="berthVisit.discharge"
         [required]="required"
         id="{{berthVisit.id}}-discharge" appDecimalNumber [maxDecimals]="0" class="form-control"
         [appCompare]="expectedDischarge"
         [compareInline]="true" [disabled]="!!berthVisit.ata || !!berthVisit.atd"
         comparePreamble="Terminal reported: ">
</app-form-group>
<app-form-group label="Load">
  <input [(ngModel)]="berthVisit.load"
         [required]="required"
         id="{{berthVisit.id}}-load" appDecimalNumber [maxDecimals]="0" class="form-control"
         [appCompare]="expectedLoad"
         [compareInline]="true" [disabled]="!!berthVisit.ata || !!berthVisit.atd"
         comparePreamble="Terminal reported: ">
</app-form-group>
<app-form-group label="Restow">
  <input [(ngModel)]="berthVisit.restow"
         id="{{berthVisit.id}}-restow" appDecimalNumber [maxDecimals]="0" class="form-control"
         [appCompare]="terminalVisit?.info?.expectedRestow"
         [compareInline]="true" [disabled]="!!berthVisit.ata || !!berthVisit.atd"
         comparePreamble="Terminal reported: ">
</app-form-group>
